<div class="card-header">
  <!-- <button class="btn btn-back" type="button" (click)="onReturn.emit($event)" title="Voltar" *ngIf="canReturnBtn">
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
  </button> -->

  <span class="header-title">
    <i class="fa fa-chevron-left click" aria-hidden="true" title="Voltar"
      (click)="onReturn.emit($event)" *ngIf="canReturnBtn">
    </i>
    {{ title }}
  </span>

  <ng-content style="height: 100%;"></ng-content>

  <div class="header-actions" [style.flex-grow]="showSaveBtn || showSaveReturnBtn || actionHeader.length > 0 ? 1 : 0">
    <button class="btn btn-success btn-action" type="button" (click)="onSaveAndReturnEmit($event)"
      *ngIf="canSave && canReturnBtn && showSaveReturnBtn" [title]="saveReturnTitle" [disabled]="disabled">
      <i class="fa fa-spinner fa-spin" *ngIf="disabled && refresh === 2"></i> {{ saveReturnCaption }}
    </button>

    <button type="button" class="btn btn-primary btn-action" (click)="onSaveEmit($event)"
      *ngIf="canSave && showSaveBtn"
      [title]="SaveTitle" [disabled]="disabled">
      <i class="fa fa-spinner fa-spin" *ngIf="disabled && refresh === 1"></i> {{ SaveCaption }}
    </button>

    <button type="button" class="btn btn-action" [disabled]="disabled" [title]="action.title"
      *ngFor="let action of actionHeader; let ih = index" (click)="executeHandler($event, ih, action)"
      [ngClass]="action.btnStyle ? action.btnStyle : 'btn-secondary'">
      <i class="fa fa-spinner fa-spin" *ngIf="disabled && refreshHeader === ih"></i> {{ action.caption }}
    </button>

    <div class="btn-group" dropdown placement="bottom right" *ngIf="canDelete || actionOption.length > 0">
      <button dropdownToggle type="button" class="btn btn-option">
        <i class="fa fa-ellipsis-v"></i>
      </button>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
        <li role="menuitem" *ngIf="canDelete">
          <a class="dropdown-item click" (click)="onDeleteEmit($event)">
            <i class="far fa-trash-alt"></i> Excluir registro
          </a>
        </li>
        <li role="menuitem" *ngFor="let action of actionOption; let io = index">
          <a class="dropdown-item click" (click)="executeHandler($event, io, action)">
            <i class="fa fa-spinner fa-spin" *ngIf="disabled && refreshOption === io"></i>
            <i [class]="action.icon" *ngIf="!disabled"></i> {{ action.caption }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
